import { Component, OnInit } from '@angular/core';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-terms-of-service-page',
  imports: [],
  templateUrl: './terms-of-service-page.html',
  styleUrl: './terms-of-service-page.scss',
})
export class TermsOfServicePage implements OnInit {
  constructor(private titleService: TitleService) {}

  ngOnInit(): void {
    this.titleService.setTitle('Terms of Service');
  }
}
